import { render, staticRenderFns } from "./clock-info.vue?vue&type=template&id=33a9b625&scoped=true&"
import script from "./clock-info.vue?vue&type=script&lang=js&"
export * from "./clock-info.vue?vue&type=script&lang=js&"
import style0 from "./clock-info.vue?vue&type=style&index=0&id=33a9b625&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a9b625",
  null
  
)

export default component.exports